import { TOPIC_BOOKMARK_PATH } from '../../shared/topicReactionMarkup';

export type EmptyStateIcon = 'book' | 'bookmark' | 'clock' | 'flame' | 'inbox' | 'message' | 'search' | 'sparkles' | 'userRoundCheck' | 'users';

const ICON_PATHS: Record<EmptyStateIcon, string> = {
	book: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5z"></path>',
	bookmark: TOPIC_BOOKMARK_PATH,
	clock: '<circle cx="12" cy="12" r="10"></circle><path d="M12 6v6l4 2"></path>',
	flame: '<path d="M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4"></path>',
	inbox: '<path d="M4 4h16v16H4z"></path><path d="M4 13h5l2 3h2l2-3h5"></path>',
	message: '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>',
	search: '<circle cx="11" cy="11" r="7"></circle><path d="m20 20-4-4"></path>',
	sparkles: '<path d="m12 3-1.6 5.4L5 10l5.4 1.6L12 17l1.6-5.4L19 10l-5.4-1.6Z"></path><path d="m19 16-.7 2.3L16 19l2.3.7L19 22l.7-2.3L22 19l-2.3-.7Z"></path>',
	userRoundCheck: '<path d="M2 21a8 8 0 0 1 13.292-6"></path><circle cx="10" cy="8" r="5"></circle><path d="m16 19 2 2 4-4"></path>',
	users: '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>',
};

export function renderEmptyStateMarkup(input: { icon: EmptyStateIcon; title: string; subtitle?: string; compact?: boolean; extraClass?: string; hostClass?: string }): string {
	const classes = ['page-empty-state', input.compact ? 'page-empty-state--compact' : '', safeClassNames(input.extraClass)].filter(Boolean).join(' ');
	const hostClasses = ['empty-state-host', input.compact ? 'empty-state-host--compact' : '', safeClassNames(input.hostClass)].filter(Boolean).join(' ');
	return `<div class="${hostClasses}">
		<div class="${classes}">
		<svg class="page-empty-state__icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">${ICON_PATHS[input.icon]}</svg>
		<p class="page-empty-state__title">${escapeHtml(input.title)}</p>
		${input.subtitle ? `<p class="page-empty-state__subtitle">${escapeHtml(input.subtitle)}</p>` : ""}
		</div>
	</div>`;
}

function safeClassNames(value: string | undefined): string {
	return (value ?? '').split(/\s+/).filter((name) => /^[A-Za-z_][A-Za-z0-9_-]*$/.test(name)).join(' ');
}

function escapeHtml(value: string): string {
	return value.replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]!);
}
